import { render, staticRenderFns } from "./v-birth-day.vue?vue&type=template&id=536211e4&scoped=true&"
import script from "./v-birth-day.vue?vue&type=script&lang=js&"
export * from "./v-birth-day.vue?vue&type=script&lang=js&"
import style0 from "./v-birth-day.vue?vue&type=style&index=0&id=536211e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536211e4",
  null
  
)

export default component.exports